import { NgModule } from '@angular/core';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardContentComponent } from './dashboard-content/dashboard-content.component';
import { AccountTransactionModule } from '../account/account-transaction/account-transaction.module';
import { AccountModule } from '../account/account.module';
import { AccountBalanceModule } from '../account/account-balance/account-balance.module';
import { UserModule } from '../user/user.module';
import { DashboardAccountWidgetComponent } from './account-widget/account-widget.component';
import { SharedModule } from '../shared/shared.module';
import { DashboardOfferWidgetComponent } from './offer-widget/dashboard-offer-widget.component';
import { BankAccountModule } from '../bank-account/bank-account.module';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { DashboardApplicationWidgetComponent } from './application-widget/application-widget.component';
import { AgreementSignersComponent } from './agreement-signers/agreement-signers.component';
import { DashboardAccountActionButtonsComponent } from './account-action-buttons/account-action-buttons.component';
import { DashboardBankWidgetComponent } from './bank-widget/bank-widget.component';
import { RecentActivityWidgetComponent } from './recent-activity-widget/recent-activity-widget.component';
import { RecentDocumentsWidgetComponent } from './recent-documents-widget/recent-documents-widget.component';
import { MfaModule } from 'common';
import { AnnouncementWidgetComponent } from './announcement-widget/announcement-widget.component';
import { LoyaltyRewardDialogComponent } from './loyalty-reward/features/loyalty-reward-dialog/loyalty-reward-dialog.component';
import { LoyaltyRewardWidgetComponent } from './loyalty-reward/features/loyalty-reward-widget/loyalty-reward-widget.component';
import { OfferAcceptedDialogComponent } from './loyalty-reward/features/offer-accepted-dialog/offer-accepted-dialog.component';

@NgModule({
  imports: [
    MatExpansionModule,
    MatButtonModule,
    MatDialogModule,
    SharedModule,
    AccountModule,
    AccountBalanceModule,
    AccountTransactionModule,
    UserModule,
    DashboardRoutingModule,
    BankAccountModule,
    MfaModule
  ],
  declarations: [
    DashboardContentComponent,
    DashboardAccountWidgetComponent,
    DashboardOfferWidgetComponent,
    AnnouncementWidgetComponent,
    DashboardApplicationWidgetComponent,
    AgreementSignersComponent,
    DashboardAccountActionButtonsComponent,
    DashboardBankWidgetComponent,
    RecentActivityWidgetComponent,
    RecentDocumentsWidgetComponent,
    LoyaltyRewardDialogComponent,
    LoyaltyRewardWidgetComponent,
    OfferAcceptedDialogComponent
  ]
})
export class DashboardModule { }
